import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '验收标准',
    type: 'UE_RULE',
}
